import { useBitcoinBalance } from "@/hooks/use-bitcoin-balance";
import { useTranslation } from "@/i18n/LanguageContext";
import { Loader2 } from "lucide-react";

interface CustomPuzzleWalletIndicatorProps {
  address: string;
}

export function CustomPuzzleWalletIndicator({ address }: CustomPuzzleWalletIndicatorProps) {
  const { data: balance, isLoading } = useBitcoinBalance(address);
  const { t } = useTranslation();
  
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-zinc-400">
        <Loader2 className="h-4 w-4 animate-spin" />
        {t("puzzles.checkingBalance")}
      </div>
    );
  }
  
  const balanceInBTC = balance ? balance / 100000000 : 0;
  
  if (balance === 0) {
    return null;
  }
  
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between bg-zinc-800/50 rounded-md p-3 border border-zinc-700">
        <div className="flex flex-col">
          <span className="text-sm text-zinc-300 font-medium">
            {t("puzzles.balance")}:
          </span>
        </div>
        <div className="text-right">
          <span className="text-emerald-400 font-mono font-bold">
            {balanceInBTC.toFixed(8)} BTC
          </span>
        </div>
      </div>
    </div>
  );
}
